module.exports = __webpack_public_path__ + "img/mountain.b12c5af0.png";